import React from 'react';
import Information from './common/Information';
import Styles from '../../styles/componentStyle/inOutHistoryUserUnregistered/inOutHistoryUserUnregistered.scss';
import { messageUtility } from '../../utilities/messageUtility';
import { replacementMessage } from '../../utilities/stringUtil';

/**
 * 不明な入退場データを実績反映した際に、
 * すでにCCUSに登録済みで反映できなかった場合に表示されるエラーダイアログ
 */
const ReflectFailedByAlreadyRegisteredErrorDialog = ({
  reqLogsLength,
  errLogs,
  visible,
  onClose,
}) => {
  const tableTitles = ['反映に失敗した不明な入退場データ', '原因の入退場実績'];
  const messageFormat = '入場日時\uFF1A{0}\u3000作業員名\uFF1A{1}';

  return (
    <Information
      title={messageUtility.getMessage('E-002-001-01')}
      rootClassName={Styles.reflectFailedByAlreadyRegisteredErrorDialog}
      message={
        <React.Fragment>
          <div className='top-message'>
            {messageUtility.getMessage(
              'E-002-001-02',
              reqLogsLength,
              errLogs.length
            )}
          </div>
          <div className='scroll-container'>
            <table className='table'>
              <thead className='table__header'>
                <tr className='table__label'>
                  <th className='value-table' />
                  {tableTitles.map((title, index) => (
                    <th
                      className={`value-table value-table--table__label`}
                      key={index}
                    >
                      <span className='value-table__label'>{title}</span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className='table__body'>
                {errLogs.map((log, index) => (
                  <tr className='table__item' key={index}>
                    <td className='value-table index'>{index + 1}</td>
                    <td className='value-table unidentified-log'>
                      <div className='value-table__message'>
                        {replacementMessage(
                          messageFormat,
                          (log &&
                            log.unidentified_log &&
                            log.unidentified_log.in_date_time) ||
                            '',
                          (log &&
                            log.unidentified_log &&
                            log.unidentified_log.worker_name) ||
                            ''
                        )}
                      </div>
                    </td>
                    <td className='value-table check-in-out-log'>
                      <div className='value-table__message'>
                        {replacementMessage(
                          messageFormat,
                          (log &&
                            log.check_in_out_log &&
                            log.check_in_out_log.in_date_time) ||
                            '',
                          (log &&
                            log.check_in_out_log &&
                            log.check_in_out_log.worker_name) ||
                            ''
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className='bottom-message'>
            {messageUtility.getMessage('E-002-001-03')}
          </div>
        </React.Fragment>
      }
      buttonText={messageUtility.getMessage('I-000-008')}
      visible={visible}
      onClose={onClose}
    />
  );
};

export default ReflectFailedByAlreadyRegisteredErrorDialog;



// WEBPACK FOOTER //
// ./src/components/modals/ReflectFailedByAlreadyRegisteredErrorDialog.jsx